import { useContext, useLayoutEffect, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import { useNavigate } from 'react-router-dom';

export default function DashboardHeader({header, theme}) {
    const { currentWebsite, currentManager, logout, fetchImage } = useContext(AppContext);
    const [imgUrl, setImgUrl] = useState("");
    const nav = useNavigate();
    useLayoutEffect(()=>{
        fetchImage(currentWebsite, `webingo_resources_def/profile/default_profile.jpg`, setImgUrl);
    },[currentWebsite, fetchImage])
    return (
        <div className='dashboard_header' style={{backgroundColor:theme.primary_color, color:theme.accent_color, textShadow:`2px 2px 4px ${theme.secondary_color}`}}>
            <div className='dashboard_logoutButton_div'>
            <button className='dashboard_logoutButton' onClick={()=>{logout(nav)}}>יציאה</button>
            </div>
            <div>
            <h1 style={{color:theme.accent_color, textShadow:`2px 2px 4px ${theme.secondary_color}`}}>{header}</h1>
            </div>
            <div className='dashboard_profileDiv'>
            <img className='dashboard_profile' src={imgUrl} alt='profile'/>
            <div className='dashboard_manager' dir='rtl'><b>מנהל האתר: </b>{currentManager?.name}</div>
            </div>
        </div>
    )
}
